import React, { useEffect, useState } from "react";
import axios from "../../../axios";
import SpinnerLoader from "../../../components/UI/SpinnerLoader/SpinnerLoader";
import * as url from "../../../utils/url";
import trivvyLogo from "../../../assets/trivvy/trivvy-logo-img.png";
import "./short-link.css";

// The only queries a short link may carry: each surface's existing
// attribution (Copy modal, QR, WhatsApp, Slack/Teams).
const ALLOWED_MEDIUMS = ["copy", "qrcode", "whatsapp", "slack"];

// TBV-938: landing page for short links — /t/ (Trivvy), /r/ (its Results) and
// /l/:code (Library item). Resolves the code on the BE and replaces history
// with the original route, so Back doesn't bounce through this page again.
// The BE only returns a relative in-app path built from its own records, so
// this can't redirect off-site; the destination page keeps enforcing login,
// privacy and publish rules exactly as it does for the long URL.
const ShortLinkRedirect = ({ match, location, history }) => {
  const [isUnavailable, setIsUnavailable] = useState(false);

  useEffect(() => {
    // Forward only a single allowlisted medium; repeated values and every
    // other parameter are dropped.
    const mediums = new URLSearchParams(location.search).getAll("medium");
    const params =
      mediums.length === 1 && ALLOWED_MEDIUMS.indexOf(mediums[0]) !== -1
        ? { medium: mediums[0] }
        : {};
    axios
      .get(url.resolveShortLinkPublic(match.params.prefix, match.params.code), { params })
      .then((res) => {
        const targetPath = res.data && res.data.data && res.data.data.targetPath;
        if (targetPath) {
          history.replace(`/${targetPath}`);
        } else {
          setIsUnavailable(true);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsUnavailable(true);
      });
  }, [match.params.prefix, match.params.code]);

  if (isUnavailable) {
    return (
      <div className="short_link_page">
        <img src={trivvyLogo} alt="Trivvy" className="short_link_logo" />
        <h5 className="mt-4">This link is invalid or no longer available.</h5>
        <p className="text-muted">
          It may have been removed or isn't published yet. Please ask the sender for a new link.
        </p>
      </div>
    );
  }

  return (
    <div className="short_link_page">
      <SpinnerLoader />
    </div>
  );
};

export default ShortLinkRedirect;
